import { StateCreator } from "zustand"
import { DutchOrderPlatesStore } from "../store"
import { DOPState } from "../../models"

export type DutchOrderPlatesSlice = {
    dutchOrderPlates: DOPState
}

export function getInitialState(): DutchOrderPlatesSlice {
    return {
        dutchOrderPlates: {
            model: {},
            errrMessage: "",
            loading: false,
        },
    }
}

export const createDutchOrderPlatesSlice: StateCreator<DutchOrderPlatesStore, [["zustand/devtools", never]], [], DutchOrderPlatesSlice> = () => ({
    ...getInitialState(),
})
